import api from './index';

// 公告类型定义
export interface Announcement {
  id: number;
  title: string;
  content: string;
  type: 'general' | 'important' | 'urgent' | 'maintenance';
  priority: number;
  status: 'draft' | 'published' | 'archived';
  author_id: number;
  author_callsign: string;
  publish_at: string | null;
  expire_at: string | null;
  view_count: number;
  is_pinned: number;
  created_at: string;
  updated_at: string;
  home_image?: string | null; // 新增首页图片字段
}

export interface AnnouncementForm {
  title: string;
  content: string;
  type: 'general' | 'important' | 'urgent' | 'maintenance';
  priority: number;
  status: 'draft' | 'published' | 'archived';
  publish_at?: string;
  expire_at?: string;
  is_pinned: number;
}

export interface PaginationData {
  page: number;
  limit: number;
  total: number;
  pages: number;
}

export interface AnnouncementsResponse {
  announcements: Announcement[];
  pagination: PaginationData;
}

// 管理员API
export const adminAnnouncementsAPI = {
  // 获取公告列表
  getList: (params?: {
    page?: number;
    limit?: number;
    status?: string;
    type?: string;
  }) => {
    return api.get('/admin/announcements', { params });
  },

  // 获取公告详情
  getDetail: (id: number) => {
    return api.get(`/admin/announcements/${id}`);
  },

  // 创建公告
  create: (data: AnnouncementForm) => {
    return api.post('/admin/announcements', data);
  },

  // 更新公告
  update: (id: number, data: AnnouncementForm) => {
    return api.put(`/admin/announcements/${id}`, data);
  },

  // 删除公告
  delete: (id: number) => {
    return api.delete(`/admin/announcements/${id}`);
  }
};

// 公开API
export const publicAnnouncementsAPI = {
  // 获取最新公告（首页用）
  getLatest: () => {
    return api.get('/announcements/latest');
  },

  // 获取公告列表
  getList: (params?: {
    page?: number;
    limit?: number;
    type?: string;
  }) => {
    return api.get('/announcements', { params });
  },

  // 获取公告详情
  getDetail: (id: number) => {
    return api.get(`/announcements/${id}`);
  }
}; 